import { connect } from 'react-redux';
import submitQuery, { cancelSearch, goToNext, goToPrev } from '../../../../shared/actions/find';
import SearchInput from '../searchInput';

const mapStateToProps = ({ find: { query } = {} }) => ({
  query,
});

const mapDispatchToProps = dispatch => ({
  sendQuery: (query, direction) => dispatch(submitQuery(query, direction)),
  goToPrev: () => dispatch(goToPrev()),
  goToNext: () => dispatch(goToNext()),
  cancelSearch: () => dispatch(cancelSearch()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchInput);
